import * as THREE from 'three'

import Experience from "./Experience"

import { MathUtils } from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'

export default class Camera
{
    constructor()
    {
        this.experience = new Experience()

        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        
        this.wheelDirection = true
        this.oldScrollValue = 0.0
        this.newScrollValue = 0.0

        this.cameraYStart = 0.0
        this.cameraYEnd = -8.0
        this.cameraYTarget = 0.0

        this.cursor = { x: 0.0, y: 0.0 }

        this.uniforms = { mousePos: { value: new THREE.Vector3() } }
        
        this.proxyMouseDebug = false
        this.proxyMouseDebugRange = new THREE.Vector2(10.0, 15.0)
        this.proxyMouseDebugPositionX = 0
        
        this.parallaxZ = 3.5
        this.parallaxValue = new THREE.Vector3(0.0, 0.0, this.parallaxZ)
        this.SphereWidth = new THREE.Vector2(1920.0, 3840.0)
        this.SphereParallaxZ = new THREE.Vector2(1.75, 2.75)

        this.proxyMouseX =
        [
            [ // DESKTOP 1920
                0.35,
                0.0,
                -0.4,
                -0.4,
                0.0,
                0.0,
                0.0 
            ],
            [ // IPAD AIR 820
                0.35,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0,
                0.0
            ]
        ]
        this.proxyMouseRanges =
        [
            new THREE.Vector2(7.5, 12.5),
            new THREE.Vector2(0.0, 0.0),
            new THREE.Vector2(25.0, 28.0),
            new THREE.Vector2(49.0, 52.0),
            new THREE.Vector2(0.0, 0.0),
            new THREE.Vector2(87.5, 89.5),
            new THREE.Vector2(0.0, 0.0),
        ]

        // this.composer = new EffectComposer(this.experience.renderer.instance)
        // this.composer.addPass(new RenderPass(this.experience.scene, this.instance))

        this.bindingEvents()
        this.setInstance()
        this.setProxyLight()
        this.setProxyMouse()
        // this.setOrbitControls()
    }
    
    bindingEvents()
    {
        //document.addEventListener('wheel', (event) => { this.wheel(event) }, false)
        document.addEventListener('mousemove', (event) => {this.trackCursor(event)}, false)
    }

    setInstance()
    {
        this.parent = new THREE.Group()
        this.instance = new THREE.PerspectiveCamera(35, this.sizes.width / this.sizes.height, 0.1, 1000)
        this.parent.add(this.instance)
        this.instance.position.set(0, 0, 3.5)
        this.scene.add(this.parent)
    }

    setFOV(value)
    {
        this.instance.fov = value
        this.instance.updateProjectionMatrix()
    }

    setOrbitControls()
    {
        this.controls = new OrbitControls(this.parent, this.canvas)
        // this.controls.enableDamping = true
        // this.controls.enableZoom = true
        // this.controls.enablePan = true
        // this.controls.minDistance = 4
        // this.controls.maxDistance = 20
        // this.controls.maxPolarAngle = Math.PI / 180 * 85
    }

    setProxyLight()
    {
        this.proxyLight_0 = new THREE.Mesh(new THREE.SphereGeometry(0.0, 1.0, 1.0), new THREE.MeshBasicMaterial())
        this.parent.add(this.proxyLight_0)
        
        this.proxyLight_1 = new THREE.Mesh(new THREE.SphereGeometry(0.0, 1.0, 1.0), new THREE.MeshBasicMaterial())
        this.parent.add(this.proxyLight_1)
    }

    setProxyMouse()
    {
        this.proxyMouse = new THREE.Mesh(new THREE.SphereGeometry(0.0, 1.0, 1.0), new THREE.MeshBasicMaterial())
        this.parent.add(this.proxyMouse)
        this.proxyMouse.position.set(0.0, -1.25, 0.0)
    }

    resize()
    {
        this.instance.aspect = this.sizes.width / this.sizes.height

        this.instance.updateProjectionMatrix()
    }

    setScrollValue(newScrollValue)
    {
        if (!this.particleObjects) return
        if (!this.gui) return
        
        this.newScrollValue = newScrollValue
        this.wheelDirection = this.oldScrollValue < this.newScrollValue
        this.oldScrollValue = this.newScrollValue

        this.particleObjects.wheelPartialValue = MathUtils.inverseLerp(0.0, 20.0, this.newScrollValue % 20.0)

        this.newScrollValue = MathUtils.clamp(this.newScrollValue, 0.0, 100.0)

        this.gui.folders[0].children[0].object.scroll = this.newScrollValue
        this.gui.folders[0].controllers[0].updateDisplay()
        
        this.particleObjects.setState()
    }

    wheel(event)
    {
        let speed = 0.5

        this.setScrollValue(this.newScrollValue + event.deltaY * 0.01 * speed)
    }

    scroll()
    {
        if (!this.particleObjects) return
        if (!this.gui) return
        let lerpScrollSpeed = 0.1
        
        //this.newScrollValue = this.particleObjects.guiValues.scroll
        
        this.cameraYTarget = MathUtils.lerp(this.cameraYStart, this.cameraYEnd, this.newScrollValue * 0.01)
        let cameraLerp = MathUtils.lerp(this.parent.position.y, this.cameraYTarget, lerpScrollSpeed).toFixed(2)
        this.parent.position.set(0.0, cameraLerp, 0.0)

        if (this.proxyMouse && this.experience.particleObjects)
        {
            if (!this.proxyMouseDebug)
            {
                if (this.experience.particleObjects.state < 0 || this.experience.particleObjects.state == 1 || this.experience.particleObjects.state == 4 || this.experience.particleObjects.state == 6)
                {
                    if (this.wheelDirection) this.proxyMouse.position.set(0.0, -3.0, 0.0)
                    else this.proxyMouse.position.set(0.0, 3.0, 0.0)
                }
                else
                {
                    if (this.stateChanged)
                    {
                        if (this.wheelDirection) this.proxyMouse.position.set(0.0, -3.0, 0.0)
                        else this.proxyMouse.position.set(0.0, 3.0, 0.0)
    
                        this.stateChanged = false
                    }
    
                    let inverseLerp = MathUtils.inverseLerp(this.proxyMouseRanges[this.experience.particleObjects.state].x, this.proxyMouseRanges[this.experience.particleObjects.state].y, this.newScrollValue)
                    let lerpY = MathUtils.lerp(this.proxyMouse.position.y, inverseLerp, 0.05)

                    if (this.experience.sizes.widthState == 0)
                    {
                        let delta = MathUtils.inverseLerp(0.0, this.experience.sizes.device["Desktop"], this.experience.sizes.width)
                        let lerpedX = MathUtils.lerp(this.proxyMouseX[1][this.experience.particleObjects.state], this.proxyMouseX[0][this.experience.particleObjects.state], delta)
                        this.proxyMouse.position.set(lerpedX, lerpY, 0.0)
                    }
                    else
                    {
                        this.proxyMouse.position.set(this.proxyMouseX[1][this.experience.particleObjects.state], lerpY, 0.0)
                    }
                }
            }
            else
            {
                let inverseLerp = MathUtils.inverseLerp(this.proxyMouseDebugRange.x, this.proxyMouseDebugRange.y, this.newScrollValue)
                let lerpY = MathUtils.lerp(this.proxyMouse.position.y, inverseLerp, 0.05)
                this.proxyMouse.position.set(this.proxyMouseDebugPositionX, lerpY, 0.0)
            }
        }
    }

    trackCursor(event)
    {
        event.preventDefault()

        this.cursor.x = event.clientX / window.innerWidth -0.5
        this.cursor.y = event.clientY / window.innerHeight -0.5

        this.uniforms.mousePos.value.set(this.cursor.x, this.cursor.y, 0.0)
    }

    parallax()
    {
        if (this.experience.sizes.widthState == 0)
        {
            let newPositionX = MathUtils.lerp(this.experience.camera.instance.position.x, this.parallaxValue.x * this.cursor.x, 0.05)
            let newPositionY = MathUtils.lerp(this.experience.camera.instance.position.y, this.parallaxValue.y * -this.cursor.y, 0.05)

            this.instance.position.set(newPositionX, newPositionY, this.parallaxValue.z)
        }
        else
        {
            this.instance.position.set(0.0, 0.0, this.parallaxValue.z)
        }
    }

    setParallaxZ()
    {
        if (this.experience.particleObjects.state == 0)
        {
            if (this.sizes.width > this.SphereWidth.x)
            {
                let newValue = MathUtils.inverseLerp(this.SphereWidth.y, this.SphereWidth.x, this.sizes.width) * this.SphereParallaxZ.y

                newValue = MathUtils.clamp(newValue, this.SphereParallaxZ.x, this.SphereParallaxZ.y)

                this.parallaxValue.lerp(new THREE.Vector3(0.0, 0.0, newValue), 0.1)
            }
            else
            {
                this.parallaxValue.lerp(new THREE.Vector3(0.0, 0.0, this.SphereParallaxZ.y), 0.1)
            }
        }
        else
        {
            this.parallaxValue.lerp(new THREE.Vector3(0.0, 0.0, this.parallaxZ), 0.1)
        }
    }

    update ()
    {
        if (!this.particleObjects)
        {
            this.particleObjects = this.experience.particleObjects
        }

        if (!this.gui)
        {
            this.gui = this.experience.gui.gui
        }

        if (!this.controls)
        {
            this.scroll()
            this.parallax()
            // this.setParallaxZ()
        }

        if (this.proxyLight_0)
        {
            this.proxyLight_0.position.setX(Math.sin(this.experience.time.timeFromBeginning * 0.5 * 0.25) * 1.5)
            this.proxyLight_0.position.setY(Math.sin(this.experience.time.timeFromBeginning * 1.0 * 0.25) * 1.0)
            this.proxyLight_0.position.setZ(Math.cos(this.experience.time.timeFromBeginning * 1.0 * 0.25) * 0.5)

            let worldPosition = new THREE.Vector3()
            this.proxyLight_0.getWorldPosition(worldPosition)
            this.particleObjects.dynamicParticleMaterial.uniforms.proxyLightPosition_0.value = worldPosition
        }

        if (this.proxyLight_1)
        {
            this.proxyLight_1.position.setX(Math.sin((this.experience.time.timeFromBeginning + 25.0) * 0.5 * 0.25) * 1.5)
            this.proxyLight_1.position.setY(Math.sin((this.experience.time.timeFromBeginning + 25.0) * 1.0 * 0.25) * 1.0)
            this.proxyLight_1.position.setZ(Math.cos((this.experience.time.timeFromBeginning + 25.0) * 1.0 * 0.25) * 0.5)

            let worldPosition = new THREE.Vector3()
            this.proxyLight_1.getWorldPosition(worldPosition)
            this.particleObjects.dynamicParticleMaterial.uniforms.proxyLightPosition_1.value = worldPosition
        }
    }
}